import React from 'react';
import { motion } from 'framer-motion';
import { FiHexagon, FiZap, FiNavigation } from 'react-icons/fi';

export default function GiantCyber({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Neo-Asset';
    const price = data?.preco || data?.price;
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1635776062127-d379bfcbb9c8';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Price Under Request';

    return (
        <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="relative w-full h-[600px] rounded-[4.5rem] p-[2px] overflow-hidden group shadow-2xl"
            style={{ 
                background: `linear-gradient(135deg, ${color || 'var(--accent-color)'} 0%, transparent 50%, ${color || 'var(--accent-color)'} 100%)` 
            }}
        >
            {/* 🌌 CONTAINER INTERNO (VOID) */}
            <div className="w-full h-full bg-[#050505] rounded-[4.4rem] overflow-hidden relative flex flex-col items-center justify-center p-12">
                
                {/* 🎥 BACKGROUND SCANNER */}
                <img 
                    src={mainImage} 
                    className="absolute inset-0 w-full h-full object-cover opacity-20 grayscale transition-all duration-1000 group-hover:scale-110 group-hover:opacity-40 group-hover:grayscale-0" 
                    alt={title}
                />
                
                {/* 🎨 OVERLAY DE GRADE (CYBER GRID) */}
                <div className="absolute inset-0 opacity-10 pointer-events-none" 
                     style={{ backgroundImage: `radial-gradient(${color || 'var(--accent-color)'} 1px, transparent 1px)`, backgroundSize: '30px 30px' }} />

                {/* 🛰️ ELEMENTOS HUD TÁTICOS */}
                <div className="absolute top-16 flex flex-col items-center gap-2 opacity-40">
                    <FiHexagon className="animate-spin-slow" style={{ color: color || 'var(--accent-color)' }} size={40} />
                    <span className="text-[8px] font-black uppercase tracking-[1em] text-white">System Sincronized</span>
                </div>

                <div className="relative z-10 text-center space-y-8">
                    {/* MARCA D'ÁGUA GIGANTE */}
                    <h2 className="text-9xl font-black text-white italic tracking-[calc(-0.1em)] opacity-5 absolute -top-20 left-1/2 -translate-x-1/2 w-full uppercase select-none">
                        FUTURE LIVING
                    </h2>
                    
                    <div className="space-y-2">
                        <span className="text-[10px] font-black uppercase tracking-[0.6em] opacity-40 text-white">
                            Asset Discovery // {data?.bairro || 'Global'}
                        </span>
                        <h3 className="text-7xl font-black text-white uppercase tracking-tighter leading-none">
                            {title}
                        </h3>
                    </div>

                    <div className="text-6xl font-black italic tracking-tighter drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]" 
                         style={{ color: color || 'var(--accent-color)' }}>
                        {formattedPrice}
                    </div>

                    <div className="pt-8">
                        <button 
                            className="px-12 py-5 rounded-full border-2 font-black uppercase text-[10px] tracking-[0.4em] transition-all hover:bg-white hover:text-black hover:scale-105 active:scale-95 flex items-center gap-4 group/btn"
                            style={{ borderColor: color || 'var(--accent-color)', color: 'white' }}
                        >
                            <FiZap className="group-hover/btn:animate-bounce" /> Iniciar Protocolo de Visita <FiNavigation />
                        </button>
                    </div>
                </div>

                {/* 🖥️ FOOTER HUD */}
                <div className="absolute bottom-12 flex gap-12 opacity-20 text-white text-[8px] font-black uppercase tracking-widest">
                    <div className="flex items-center gap-2"> <div className="w-1 h-1 bg-white rounded-full" /> 0.7782-X </div>
                    <div className="flex items-center gap-2"> <div className="w-1 h-1 bg-white rounded-full" /> MOS_CYBER_V11 </div>
                    <div className="flex items-center gap-2"> <div className="w-1 h-1 bg-white rounded-full" /> ENC_SEC_GATE </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                .animate-spin-slow {
                    animation: spin-slow 12s linear infinite;
                }
            `}</style>
        </motion.div>
    );
}